import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationApiService } from 'src/app/_services/notification-api.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.css']
})
export class NotificationComponent implements OnInit {
  @Input() isHomePageNotScrolled: boolean = false;
  showDropdown = false;
  notificationList:any = [];

  itemsPerPage:number =  0; 
  currentPage:number = 1;
  totalPages:number = 0;



  constructor(private apiService: NotificationApiService,private router: Router) { }

  ngOnInit(): void {
    this.getNotificationData({ page: 1,itemsPerPage:10, searchKey:'' });
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  getNotificationData(params?: any) {
    this.apiService.getNotification(params).subscribe(
      (data: any) => {
        console.log("notification api response = ", data.data.notifications);
        if (data.meta.status) {
          this.notificationList = data.data.notifications;
          // this.menuItems = data.data;
          // this.totalPages = data.pagination.pages
          // this.currentPage = data.pagination.page
          // this.itemsPerPage = data.pagination.limit
        }
      }
    )
  }

  handleViewAll() {
    this.router.navigate(['/notifications']);
  }

   @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.notification-wrapper')) {
      this.showDropdown = false;
    }
  }

}
